import { PostHogProvider, usePostHog } from '@posthog/react';
import { useStoreState } from '@seller-hermes/hooks/easy-peasy';
import { useEffect } from 'react';

function PostHogRegisterUser() {
  const posthog = usePostHog();
  const user = useStoreState((s) => s.login.sellerGroupUser.user);

  useEffect(() => {
    if (!posthog || !user) return;

    const payload = {
      seller_group_name: user.seller_group?.name ?? '',
      user_email: user.email ?? '',
    };

    posthog.identify(user.email);

    posthog.register(payload);

    return undefined;
  }, [posthog, user?.id, user?.email, user?.seller_group?.name]);

  return null;
}

type Props = {
  apiKey: string;
  options?: object;
  children: React.ReactNode;
};

export function PostHogProviderWithUser({ apiKey, options, children }: Props) {
  return (
    <PostHogProvider apiKey={apiKey} options={options}>
      <PostHogRegisterUser />
      {children}
    </PostHogProvider>
  );
}
